/* React Higher Order Component which fetches short course doc for given id and version 
    Child (InnerComponent) will only render once short course doc is successfully fetched.
    child will receive props: {
        doc: PropTypes.object,
        fatalError: PropTypes.object,
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseVersion: PropTypes.string,
    forceRefreshOnMount: PropTypes.bool,
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    shortCourseVersion: null,
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withShortCourseDoc(WrappedComponent) {
    class WithShortCourseDoc extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                getActionId: null,
                fatalError: null
            }

            this.getDoc = this.getDoc.bind(this);
            this.getStoreData = this.getStoreData.bind(this);
            this.unsubscribes = [ShortCourseStore.listen(this.onShortCourseStoreChange.bind(this))];
        }

        componentDidMount() {
            //console.log('this.getStoreData(this.props.channelId, this.props.projectId, this.props.shortCourseId, this.props.shortCourseVersion)', this.getStoreData(this.props.channelId, this.props.projectId, this.props.shortCourseId, this.props.shortCourseVersion));
            if (
                !this.getStoreData(this.props.channelId, this.props.projectId, this.props.shortCourseId, this.props.shortCourseVersion)
                || this.props.forceRefreshOnMount
            ) {
                this.getDoc(this.props.channelId, this.props.shortCourseId, this.props.shortCourseVersion);
            }
        }

        componentDidUpdate(prevProps) {
            if (
                this.props.channelId !== prevProps.channelId
                || this.props.projectId !== prevProps.projectId
                || this.props.shortCourseId !== prevProps.shortCourseId
                || this.props.shortCourseVersion !== prevProps.shortCourseVersion
            ) {
                if (!this.getStoreData(this.props.channelId, this.props.projectId, this.props.shortCourseId, this.props.shortCourseVersion) || this.props.forceRefreshOnMount) {
                    this.getDoc(this.props.channelId, this.props.shortCourseId, this.props.shortCourseVersion);
                }
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        getDoc(channelId, shortCourseId, shortCourseVersion) {
            const actionId = uuid.v4();
            this.setState({ getActionId: actionId }, () => {
                ShortCourseActions.getShortCourseWithDocAtVersion(
                    actionId, 
                    {
                        channelId: channelId,
                        shortCourseId: shortCourseId,
                        shortCourseVersion: !!shortCourseVersion ? shortCourseVersion : undefined,
                    }
                );
            });
        }

        onShortCourseStoreChange(newState) {
            //console.log('newState', newState);
            let updatedState = {};
            if (newState.action.id === this.state.getActionId) {
                updatedState = { ...updatedState, getActionId: null };
                if (!!newState.action.error) {
                    updatedState = { ...updatedState, fatalError: newState.action.error };
                }
            }

            this.setState({
                ...updatedState,
            });
        }

        getStoreData(channelId, projectId, shortCourseId, shortCourseVersion) {
            const shortCourseStoreState = ShortCourseStore.getStateShortCourse(shortCourseId, projectId, channelId);
            if (!shortCourseStoreState.initialized) {
                //console.log('1', shortCourseStoreState);
                return null;
            }
            const shortCourse = shortCourseStoreState.shortCourse;
            if (shortCourse && !shortCourse.activity_types) {
                //console.log('1.5', shortCourseStoreState);
                return false;
            }

            const parsedVersion = !!shortCourseVersion ? shortCourseVersion : undefined
            const doc = ShortCourseStore.getShortCourseDoc(shortCourseId, parsedVersion).doc;
            if (!doc) {
                //console.log('2');
                return null;
            }

            return { shortCourse, doc };
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace />;
            }

            const storeData = this.getStoreData(this.props.channelId, this.props.projectId, this.props.shortCourseId, this.props.shortCourseVersion);
            //console.log('storeData', storeData)
            if (!storeData) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    shortCourse={storeData.shortCourse}
                    doc={storeData.doc}
                />
            );
        }
    }

    WithShortCourseDoc.propTypes = propTypes;
    WithShortCourseDoc.defaultProps = defaultProps;
    WithShortCourseDoc.displayName = `WithShortCourseDoc(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithShortCourseDoc;
}
